import React, { useEffect, useState } from 'react';

import CityDropdown from '../dropdown/city';

import StateDropdown from '../dropdown/states';

import CountryDropdown from '../dropdown/country';

import { Skeleton } from 'primereact/skeleton';

type Props = {
    id: string;

    countryValue: string;

    cityValue: string;

    stateValue: string;
};

const StateCityCodeValue: React.FC<Props> = ({ id, countryValue, cityValue, stateValue }) => {
    const [showSkeleton, setShowSkeleton] = useState(true);

    const [iso2CountryString, setIso2CountryString] = useState('');

    const [iso2StateString, setIso2StateString] = useState('');

    useEffect(() => {
        const alphabetPattern = /^[A-Za-z]+$/;

        if (!countryValue) {
            setTimeout(() => {
                setShowSkeleton(false);
            }, 2000);
        } else if (alphabetPattern.test(countryValue)) {
            setTimeout(() => {
                setShowSkeleton(false);
            }, 2000);
        }

        if (!countryValue) {
            setShowSkeleton(false);
        } else if (stateValue === 'null' || cityValue === 'null') {
            setShowSkeleton(false);
        } else if (stateValue === '' || cityValue === '') {
            setShowSkeleton(false);
        }
    }, [cityValue, countryValue, stateValue]);

    return (
        <>
            <span>
                <span style={{ display: `${showSkeleton ? 'block' : 'none'}` }}>
                    <Skeleton width="12rem" className="mb-2 custom-skeleton"></Skeleton>
                </span>

                <span style={{ display: `${showSkeleton ? 'none' : 'flex'}` }}>
                    <>
                        {cityValue && iso2CountryString && iso2StateString ? (
                            <>
                                <CityDropdown
                                    id={id + Math.random() + 1}
                                    cityFieldValue={cityValue}
                                    iso2CountryString={iso2CountryString}
                                    iso2StateString={iso2StateString}
                                    setShowSkeleton={setShowSkeleton}
                                />
                                &nbsp;
                            </>
                        ) : (
                            ''
                        )}
                        {stateValue && iso2CountryString ? (
                            <>
                                <StateDropdown
                                    id="stateResult"
                                    Iso2CountryString={iso2CountryString}
                                    stateFieldValue={stateValue}
                                    setIso2StateString={setIso2StateString}
                                    setShowSkeleton={setShowSkeleton}
                                />
                            </>
                        ) : (
                            ''
                        )}
                        &nbsp;
                        {countryValue && (
                            <>
                                <CountryDropdown
                                    id="countryResult"
                                    countryFieldValue={countryValue}
                                    setIso2CountryString={setIso2CountryString}
                                    setShowSkeleton={setShowSkeleton}
                                />
                            </>
                        )}
                        &nbsp;
                    </>
                </span>
            </span>
        </>
    );
};

export default StateCityCodeValue;
